// 8-20 邱总：弹窗要能上下左右拖动（原来固定在屏幕中间挪不动）
// 用法：<el-dialog v-dialog-drag ...>  —— 按住标题栏拖，双击标题栏回到中间
import Vue from 'vue'

Vue.directive('dialog-drag', {
  bind(el) {
    const header = el.querySelector('.el-dialog__header')
    const dialog = el.querySelector('.el-dialog')
    if (!header || !dialog) return

    header.style.cursor = 'move'
    dialog.style.marginTop = dialog.style.marginTop || '15vh'

    const getStyle = (dom, key) => {
      const style = window.getComputedStyle(dom, null)
      return style[key]
    }

    header.onmousedown = (e) => {
      // 点标题栏上的关闭按钮不算拖动
      if (e.target && e.target.closest && e.target.closest('.el-dialog__headerbtn')) return

      const disX = e.clientX - header.offsetLeft
      const disY = e.clientY - header.offsetTop

      let styL = getStyle(dialog, 'left')
      let styT = getStyle(dialog, 'top')
      if (styL.indexOf('%') !== -1) {
        styL = +document.body.clientWidth * (+styL.replace('%', '') / 100)
        styT = +document.body.clientHeight * (+styT.replace('%', '') / 100)
      } else {
        styL = +styL.replace('px', '')
        styT = +styT.replace('px', '')
      }

      document.onmousemove = (ev) => {
        const l = ev.clientX - disX
        const t = ev.clientY - disY
        dialog.style.left = `${l + styL}px`
        dialog.style.top = `${t + styT}px`
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }

    // 双击标题栏复位
    header.ondblclick = () => {
      dialog.style.left = ''
      dialog.style.top = ''
    }
  }
})
